
import MyAccount from "./MyAccount";
import SendCoin from "./SendCoin";

import Marquee from "./Marquee";

const Accounts = () => {
  return (
    <div className="p-8" >
      <SendCoin/>
    </div>
    // <div className="grid grid-cols-1 lg:grid-cols-4 p-8 gap-10  ">
    //   <div className=" w-full lg:col-span-1">
    //     {" "}
    //     <MyAccount />
    //   </div>
    //   <div className="w-full lg:col-span-3">
    //     {" "}
    //     <SendCoin />
    //   </div>
    //   <div className="pt-8 lg:col-span-4 ">
        
    //   </div>

    //   {/* <div className="text-4xl" onClick={contractinfo}> Check Connection </div> */}
    // </div>
  );
};

export default Accounts;
